export default __webpack_public_path__ + "static/media/princess-cruises-nav-horizontal.668b6ab1.svg";